export default __webpack_public_path__ + "static/media/place_your_token.86552b2f.mp3";